import React from 'react';
import { Text, Flex } from '@badi/badi-components';
import { translate } from 'base/shared/Localization';
import { LocationPopoverWrapper } from '../styled-components';

const LocationSelectorPopover = () => (
  <LocationPopoverWrapper>
    <Flex
      alignItems="center"
      background={BADI_COLORS.NEUTRAL.NEUTRAL_00}
      borderRadius={6}
      direction="column"
      gutter={1}
      justify="center"
      padding={2}
      shadow="medium"
    >
      <Text body="14-Regular" color={BADI_COLORS.NEUTRAL.NEUTRAL_80}>
        {translate('search.home_location_required')}
      </Text>
    </Flex>
  </LocationPopoverWrapper>
);

export default LocationSelectorPopover;
